module.exports = __webpack_public_path__ + "static/media/learnstability.5c67f2c7.svg";